import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import ReHeader from '../../../basic/re_header';
import ReFooter from '../../../basic/alive-footer';
export default {
  name: 'indexmaterial',
  components: {
    'website-header': ReHeader,
    'website-footer': ReFooter
  },
  data: function data() {
    return {
      downloads: {}
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.downloads = {
              applestore: 'https://apps.apple.com/us/app/id1487793975',
              android: 'https://guanwang.onelink.me/IXGk/Alive0803Android'
            };
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  methods: {}
};